import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import ErrorLabel from "../error";
export const countriesCode = [
    { code: '966', DescriptionAr: 'السعودية', DescriptionEn: 'Saudi Arabia', flag: 'saudiFlag.png' },
    // {code:'967',descriptionAr:'اليمن',descriptionEn:'Yemen' , flag = 'yemenFlag.png'},
    { code: '49', DescriptionAr: 'المانيا', DescriptionEn: 'Germany', flag: 'germanyFlag.png' },
    { code: '55', DescriptionAr: 'البرازيل', DescriptionEn: 'Brazil', flag: 'brazilFlag.png' }
];
const PhoneDropDown = ({ onChangeValue, errorLabel, defaultValue = '', value,defultValue, defaultFlag = null, maxLength = 12 ,title=""}) => {
    const defaultFlagPath = '/assets/flags/';
    const { t: trans } = useTranslation(["mobileForm", "mobileModel"]);
    const [isOpened, setIsOpened] = useState(false);
    const [isFocus, setIsFocus] = useState(false);
    const [activeFlag, setActiveFlag] = useState(defaultFlag ?? {
        flagText: '966',
        flag: defaultFlagPath + 'saudiFlag.png'
    });
    const [phoneValue, setPhoneValue] = useState(value);
    const flagRef = useRef();
    const inputRef = useRef();
    let lang = localStorage.getItem("i18nextLng");
    const languageDir = 'language-' + lang;
    useEffect(() => {
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [flagRef, isOpened]);

    useEffect(() => {
        if (value == '')
            setPhoneValue(value);
    }, [value]);

    useEffect(() => {
        if (defultValue)
            setPhoneValue(defultValue);
    }, [defultValue]);
    const handleChangeCountryCodeStatus = () => {
        const newStatus = !isOpened;
        setIsOpened(newStatus);
    };
    const handleClickOutside = (event) => {
        if (flagRef.current && !flagRef.current.contains(event.target) && isOpened === true) {
            setIsOpened(false);
            setIsFocus(false);
        }
    };
    const handleChangeCountryCode = (item) => {
        let { code, flag } = item;
        setActiveFlag({
            flagText: code,
            flag: defaultFlagPath + flag
        });
        setIsOpened(false);
        inputRef.current.focus();
    };
    const handleInputChange = (event) => {
        if (event.target.validity.valid) {
            setPhoneValue(event.target.value);
            if (onChangeValue) {
                onChangeValue(activeFlag.flagText, event.target.value);
            }
        }
    };
    return (
        <div className={"input " + languageDir}>
            <div className="selectable-drop ">
                <div className={`phone-selectable border-none  nice-shadow-2 ${errorLabel && 'border-danger'} phone-selectable-bg-white ${isFocus ? 'active-border' : ''}`}>
                    <div className="phone-selectable-country-box" onClick={handleChangeCountryCodeStatus}>
                        <div className="nice-flex nice-flex-row p-2">
                            <div className='nice-flex'>
                                <div className="phone-selectable-flex phone-selectable-flex-rows items-center text-left">
                                    <span className="mx-1 text-20 text-left text-bold">
                                        {'+(' + activeFlag.flagText + ')'}
                                    </span>
                                </div>
                            </div>

                            <div className={`text-inline-block flag-btn flag-btn-${isOpened ? 'open' : 'close'}`}>
                                <img src="/assets/icons/arrow.svg" alt="arrow" />
                            </div>
                        </div>

                    </div>
               
                    <input maxLength={maxLength} pattern="[0-9]*" onFocus={() => { setIsFocus(true) }}
                     onBlur={() => { setIsFocus(false) }} value={phoneValue} 
                     onInput={(e) => { handleInputChange(e) }} type="phoneNumber" ref={inputRef}
                      className="phone-selectable-input text-30 input-field" style={{ right: (lang == 'en' ? '-20%' : 'auto') }}
                       placeholder={title} />
                            <div className="border-l text-gray my-5"></div>
                </div>
                {
                    isOpened && (<div className="phone-selectable-country-box-list" ref={flagRef}>
                        <ul className="list-unstyle">
                            {
                                countriesCode.map((item, index) => {
                                    return <li className="phone-selectable-country-box-list-item p-3" key={index} onClick={() => {
                                        handleChangeCountryCode(item);
                                    }}>
                                        <span className="mx-2 text-20 text-left">
                                            {item[`${trans("mobileModel:description2")}`]}
                                        </span>
                                        <div className="text-left">
                                            <span className="text-inline-block mx-2 text-20 text-bold">
                                                {'+(' + (item.code) + ')'}
                                            </span>
                                        </div>
                                    </li>
                                })
                            }
                        </ul>
                    </div>)
                }
            </div>
        </div>

    );
};
export default PhoneDropDown;
